import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { Nullable } from 'global';
import { useQuote, QuoteCalcViewModel } from 'modules/quote';
import { dealBuilderApi, DealBuilderEntity, GetActiveDealBuilderResponse, GetActiveDealBuilderVariables } from '../api';

export interface UseDealSummaryFetchResult {
  activeEntity: Nullable<DealBuilderEntity>;
  loading: boolean;
  priceCalc: Nullable<QuoteCalcViewModel>;
}

export const useDealSummaryFetch = (vendorOpportunityId: string | undefined): UseDealSummaryFetchResult => {
  const [priceCalc, setPriceCalc] = useState<Nullable<QuoteCalcViewModel>>(null);
  const { handleFetchQuoteCalcById, isQuoteCalcLoading } = useQuote();

  const { data, loading: isActiveDealBuilderLoading } = useQuery<
    GetActiveDealBuilderResponse,
    GetActiveDealBuilderVariables
  >(dealBuilderApi.getActiveDealBuilder, {
    variables: { vendorOpportunityId: vendorOpportunityId! },
    skip: !vendorOpportunityId,
    onCompleted: response => {
      const quoteId = response?.dealBuilder?.getActiveDealBuilder?.entity?.quote?.quoteId;
      if (!quoteId) {
        setPriceCalc(null);
        return;
      }
      handleFetchQuoteCalcById(quoteId).then(setPriceCalc);
    },
  });

  const activeEntity = data?.dealBuilder?.getActiveDealBuilder?.entity ?? null;

  return {
    activeEntity,
    priceCalc,
    loading: isActiveDealBuilderLoading || isQuoteCalcLoading,
  };
};
